import { RecentChat } from '~redux/recent/types'
import { ExistingChat } from '~types'

export default function (chat: ExistingChat | RecentChat): {
  classId?: string
  chatId?: string
  userId?: string
} {
  // Recent chats store full path with query arguments
  const match = chat?.path?.match(
    /^(?:folders|classes)\/(?<classId>[^/]+)\/chats\/(?<chatId>[^/?]+)(?:\?userId=(?<userId>[^/]+))?$/,
  )

  if (match?.groups) {
    return match.groups
  }

  const replyMatch = chat?.path?.match(
    /^users\/(?<userId>[\da-zA-Z]+)\/chats\/(?<chatId>[\da-zA-Z]+)$/,
  )

  if (replyMatch?.groups && chat?.parent_class_id) {
    return {
      ...replyMatch?.groups,
      classId: chat?.parent_class_id,
    }
  }

  return {
    classId: undefined,
    chatId: undefined,
    userId: undefined,
  }
}
